import styled from 'styled-components';
import { cvBreakpoint768 } from '@carvana/theme';


export const ButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 40px;

  @media (min-width: ${cvBreakpoint768}px) {
    flex-direction: row;
    justify-content: center;
  }
`;

export const Container = styled.div`
  background-color: white;
`;

export const HeaderContainer = styled.div`
  background-color: ${props => props.theme.carvana.gray.background};
  padding: 35px 40px;
`;

export const HeaderTextBold = styled.h2`
  color: ${props => props.theme.carvana.blue.dark};
  margin-bottom: 6px;
`;

export const HeaderText = styled.p`
  color: ${props => props.theme.carvana.gray.dark};
`;

export const BodyContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 0 40px 40px;
`;

export const AddressContainer = styled.div`
  border-bottom: 1px solid ${props => props.theme.carvana.gray.light};
  padding: 25px 0;
  width: 100%;
`;
